import { BaseIcon, BaseIconProps } from '../BaseIcon';

export type SuccessIconProps = Omit<BaseIconProps, 'children'>;

export const SuccessIcon = ({ ...props }: SuccessIconProps) => (
  <BaseIcon width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 12C4 7.6 7.6 4 12 4C16.4 4 20 7.6 20 12C20 16.4 16.4 20 12 20C7.6 20 4 16.4 4 12ZM11.2072 15.2071L16.7072 9.70712L15.293 8.29291L10.5001 13.0858L8.70718 11.2929L7.29297 12.7071L9.79297 15.2071C10.1835 15.5976 10.8167 15.5976 11.2072 15.2071Z"
      stroke="none"
    />
  </BaseIcon>
);

SuccessIcon.displayName = 'SuccessIcon';
